import React from "react";
import { Link } from "react-router-dom";

const SignDesc = ({ statusAcc, textLink, to }) => {
  return (
    <p className="sign-form__desc">
      {statusAcc} memiliki akun?{" "}
      <Link to={to} className="sign-form__link">
        {textLink}
      </Link>
    </p>
  );
};

export default SignDesc;
